import React from "react";
import { useMutation, useQuery } from "@apollo/client";
import { LoadingSpinner, ServerError } from "components/graphql-views";
import { createPlan, pricingAllForPlans } from "types/gql-types";
import { AdminHeading } from "../shared/admin-form";
import { useAdminSubmit } from "../shared/use-admin-submit";
import PlanForm, { PlanForm as PlanFormType } from "./form";
import { buildPlanMutationData } from "./plan-form-utils";
import { CREATE_PLAN, GET_PRICING_ALL_FOR_PLANS } from "./queries";
import { formatPlanPricingOptions, NoPricingWarning } from "./plan-utils";

const initialData: PlanFormType = {
  name: "",
  description: "",
  isPublic: false,
  defaultPricingId: "",
  invoicedPlanIdAnnually: "",
  invoicedPlanIdQuarterly: "",
};

const NewPlan: React.FC = () => {
  const { sending, submit } = useAdminSubmit("/dash/admin/plans");
  const [createPlanFunc] = useMutation<createPlan>(CREATE_PLAN, {
    refetchQueries: ["plansAll"],
  });

  const { data: pricingData, loading, error } = useQuery<pricingAllForPlans>(
    GET_PRICING_ALL_FOR_PLANS,
    { fetchPolicy: "cache-and-network" },
  );

  const submitForm = (formData: PlanFormType) =>
    submit(() =>
      createPlanFunc({
        variables: { data: buildPlanMutationData(formData) },
        refetchQueries: ["plansAll"],
      }));

  const pricingOptions = formatPlanPricingOptions(pricingData?.pricingAll);

  return (
    <div>
      <AdminHeading>Create Subscription Plan</AdminHeading>
      {loading && <LoadingSpinner />}
      {error && <ServerError desc={error.message} />}
      {!loading && !error && (
        <>
          {pricingOptions.length === 0 && <NoPricingWarning />}
          <PlanForm
            formType="new"
            initialData={initialData}
            sending={sending}
            handleSubmit={submitForm}
            pricingOptions={pricingOptions}
          />
        </>
      )}
    </div>
  );
};

export default NewPlan;
